import { ResetEmailPasswordResponse } from '../../../api/hub-responses/reset-email-password-response';
import { getHubApi } from '../accountServiceApi/getAccountServiceApi';

export type ResetEmailPasswordRequest = {
    email: string,
    locale: string
}

export function resetEmailPassword(data: ResetEmailPasswordRequest): Promise<ResetEmailPasswordResponse> {
    const hubApi = getHubApi();
    return hubApi.resetEmailPassword(window.app.deviceIdentifier, data) as Promise<ResetEmailPasswordResponse>;
}
